import React from "react"

import * as st from './Screen.styled.js'

const Screen = ({
  className,
  id,
  image,
  Icon,
}) => (
  <st.Wrap className={className}>
    {Icon && (
      <st.Icon key={id}>
        <Icon />
      </st.Icon>
    )}
    {image && (
      <img
        src={image.src}
        srcSet={`${image.src} 1x, ${image.src2x} 2x`}
        width={image.width}
        height={image.height}
        alt={id}
      />
    )}
  </st.Wrap>
)

export default Screen
